exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#editProcessButtonX{padding:0px;color:#222222;cursor:pointer}#editProcessButtonX::before{content:'\\e944';font-family:'e-icons';font-size:13px}\n", ""]);

